import { render, staticRenderFns } from "./product-manage.vue?vue&type=template&id=38452592&scoped=true"
import script from "./product-manage.vue?vue&type=script&lang=js"
export * from "./product-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38452592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38452592')) {
      api.createRecord('38452592', component.options)
    } else {
      api.reload('38452592', component.options)
    }
    module.hot.accept("./product-manage.vue?vue&type=template&id=38452592&scoped=true", function () {
      api.rerender('38452592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backend/components/product-manage.vue"
export default component.exports